/**
 * Porta il browser a una pagina esterna (pagamento o portale di Stripe),
 * nella stessa scheda. A parte perche' i test possano sostituirla: jsdom non
 * lascia cambiare window.location.
 */
export function apriEsterno(url) {
  window.location.assign(url);
}
